import { useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import {InputField} from "../../Shared/InputField"

const VillagesForm = (props) => {
    const [errors, setErrors] = useState({})
    const [isLoading, setIsLoading] = useState(false)

    const [formData, setFormData] = useState({
        name: '',
        alias: '',
        contact: '',
        public_id: ''
    })
    const {name, alias, contact, public_id} = formData

    const navigate = useNavigate()
    const location = useLocation()

    useEffect (() => {
        if (location.state){
            const {village} = location.state
            setFormData({
                name: village.name,
                alias: village.alias,
                contact: 'Abdullahi Hersi',
                public_id: village.public_id
            })
        }

    }, [location])

    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value
        }))
    }

    const onSubmit = (e) => {
        e.preventDefault()

        const villageData = {name, alias, contact}

        if(public_id !== ''){
            updateVillage(public_id, villageData)
        }else {
            addVillage(villageData)
        }
    }

    //update village
    const updateVillage = async (public_id, villageData) => {
        try {
            setIsLoading(true)
            const response = await Server.put(`/villages/${public_id}`, villageData)
            if(response.status === 200){
                toast.success('Successfully updated')
                navigate('/villages')
                setIsLoading(false)
            }else{
                setIsLoading(false)
                toast.error(response.data?.detail)
            }
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                navigate('/login')
            }else if (error.response.status === 422) {
                setErrors({})
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error.response.data.detail);
            }
        }
    }
    
    // add village
    const addVillage = async (villageData) => {
        setIsLoading(true)
        try {
            const response = await Server.post('/villages/', villageData)
            if (response.status === 201){
                navigate('/villages')
                setIsLoading(false)
            }else{
                toast.error(response.data?.detail)
            }
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                navigate('/login')
            }else if (error.response.status === 422) {
                setErrors({})
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error.response.data.detail);
            }
        }
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Create New Village</h3>
            </div>
            <div className="card-body">
                <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-6">
                            <InputField
                                placeholder="Village Name"
                                name="name"
                                type="text"
                                label="Name"
                                value={name}
                                onChange={onChange}
                                error={errors.name}
                            />
                        </div>

                        <div className="col-md-6">
                        <InputField
                            placeholder="Village Alias"
                            name="alias"
                            type="text"
                            label="Alias"
                            value={alias}
                            onChange={onChange}
                            error={errors.alias}
                        />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Save Village" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
    </>
  )
}

export default VillagesForm
